<template>
  <ul v-show="(mouseInfo.visible)" :style="getPositionInfo" class="context-menu">
    <!--区分光标和选择文字-->
    <template v-if="((mouseInfo.type)==='source')">
      <!--右键-->
      <!-- <template v-if="!(mouseInfo.selectText)">
        <li @click="()=>handleCopyToTarget(mouseInfo)">复制原文到译文</li>
        <li @click="()=>handleClear(mouseInfo)">清除译文</li>
        <li @click="()=>handleAddRemark(mouseInfo)">添加备注</li>
        <li @click="()=>handleSplitFrangment(mouseInfo)">拆分</li>
        <li @click="()=>handleDownMerge(mouseInfo)">向下合并</li>
      </template> -->
      <!--划词-->
      <template v-if="(mouseInfo.selectText)">
        <li class="set-font" @click="handleClick($event)" v-if="false">
          <div class="set-font-inside">
            <span>字体设置</span>
            <i class="icon">➤</i>
          </div>
          <div class="children-menu">
            <p>粗体</p>
            <p>斜体</p>
            <p>下划线</p>
            <p>删除线</p>
          </div>
        </li>
        <li v-if="getUrlTypeInfo!=='school'" @click="handleSearchMemory($event)">在翻译记忆库中搜索</li>
        <li @click="()=>handleClickSearch()">在网页中搜索</li>
        <li v-if="getUrlTypeInfo!=='school'" @click="()=>handleAddTerm('second')">添加术语库</li>
        <li v-if="false">复制/粘贴</li>
      </template>
    </template>
    <template v-if="((mouseInfo.type)==='target')">
      <!--右键-->
      <template v-if="!(mouseInfo.selectText)">
        <li @click="()=>handleClear(mouseInfo)">清除译文</li>
        <li @click="()=>handleAddRemark(mouseInfo)">添加备注</li>
      </template>
      <!--划词-->
      <template v-if="((mouseInfo.selectText) || (!(getUrlTypeInfo==='school')))">
        <li class="set-font" @click="handleClick($event)" v-if="false">
          <div class="set-font-inside">
            <span>字体设置</span>
            <i class="icon">➤</i>
          </div>
          <div class="children-menu">
            <p>粗体</p>
            <p>斜体</p>
            <p>下划线</p>
            <p>删除线</p>
          </div>
        </li>
        <li @click="()=>handleClickSearch()">在网页中搜索</li>
        <li v-if="false">复制/粘贴</li>
      </template>
    </template>
  </ul>
</template>

<script>
export default {
  name: "MouseRight",
  props: {
    mouseInfo: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      visibleRemarks: false,
    };
  },

  computed: {
    getPositionInfo: function () {
      //不使用命名空间
      let positionInfo = this.$store.getters['editor/getPositionInfo'];
      return { ...positionInfo }
    },

    //获取url信息
    getUrlTypeInfo() {
      const urlInfo = this.$store.getters['editor/getUrlInfo'];
      if (!!urlInfo && !!(urlInfo.type)) {
        return (urlInfo.type)
      }
      return ''
    },
  },
  methods: {
    handleClick(e) {
      console.log(`${e.clientX + 10}px`);
      console.log(`${e.clientY + 10}px`)
    },

    //复制到译文
    handleCopyToTarget(info) {
      const self = this;
      if (Reflect.has(info, 'type') && ((info.type) === 'source')) {
        let item = (info.currentItem);
        let urlInfo = self.$store.getters['editor/getUrlInfo'];
        let fileId = 0;
        if ((urlInfo.type) === 'project') {
          let fileInfo = self.$store.getters['editor/getFileInfo'];
          fileId = (fileInfo.id);

        } else if ((urlInfo.type) === 'task' || (urlInfo.type) === 'school') {
          let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
          fileId = (fileTaskInfo.fileId);
        }

        let source = (document.getElementById(`source-${item.id}`).innerHTML) || '';
        // document.getElementById(`target-${item.id}`).innerHTML = source;
        // //重新机翻成功后再做一次译文的更新处理
        let params = Object();
        Reflect.set(params, 'constTime', 0);
        Reflect.set(params, 'taskId', null);
        Reflect.set(params, 'taskType', null);
        Reflect.set(params, 'isSaveVersion', 1);
        Reflect.set(params, 'sentId', (item.id));
        Reflect.set(params, 'content', source);
        Reflect.set(params, 'status', (item.status));
        Reflect.set(params, 'fileId', fileId);
        if (item.tagSourceSent) {
          let targetTemp = Object();
          let SourceTag = JSON.parse(item.tagSourceSent).fragments[0].atoms;
          Reflect.set(targetTemp, 'sort', 0);
          Reflect.set(targetTemp, 'text', null);
          Reflect.set(targetTemp, 'type', null);
          Reflect.set(targetTemp, 'atoms', SourceTag);
          Reflect.set(params, 'sourceTagFragmentVo', null);
          Reflect.set(params, 'targetTagFragmentVo', targetTemp);
        }
        self.$store.dispatch('editor/updateTargetInfo', { params: params, type: 1 });
      }
    },
    //添加术语
    handleAddTerm(value) {
      let editorModeInfo = this.$store.getters['editor/getEditorModeInfo'];
      const self = this;
      let keyword = (self.mouseInfo.selectText);
      // 选中文字后弹出菜单点击添加术语原文赋值为 鼠标选中后右击选中的
      let params = {
        column: value,
        keyword: keyword
      };
      this.$store.dispatch('editor/setOerationSignInfo', params)

    },
    //添加批注信息
    handleAddRemark(param) {
      // 批注弹出-调用父级的方法-关闭右键
      let params = {
        id: (param.id),
        sourceSent: (param.currentItem.sourceSent),
        sourceWordNum: (param.currentItem.sourceWordNum),

      };
      this.$emit('handleRemarks', params)
    },
    //网页检索
    handleClickSearch() {
      const self = this;
      let searchKeyword = (self.mouseInfo.selectText);
      const getUrlInfo = this.$store.getters["editor/getUrlInfo"];
      if (searchKeyword) {
        searchKeyword = encodeURIComponent(searchKeyword.replace(/\u00a0/g, " "));
        const search = parseInt(self.$store.getters['editor/getSearchInfo']);
        switch (search) {
          case 1:
            window.open(`https://www.baidu.com/s?wd=${searchKeyword}`);
            break;
          case 2:
            window.open(`https://www.google.com/search?q=${searchKeyword}`);
            break;
          case 3:
            window.open(`https://www.sogou.com/web?query=${searchKeyword}`);
            break;
          case 4:
            window.open(`https://cn.bing.com/search?q=${searchKeyword}`);
            break;
          case 5:
            window.open(`http://www.iciba.com/word?w=${searchKeyword}`);
            break;
          case 6:
          window.open(
              `https://youdao.com/result?word=${searchKeyword}&lang=${getUrlInfo.sourceLang}`
            );
            break;
        }
      }
    },
    //清空译文
    handleClear(info) {
      const self = this;
      let item = (info.currentItem);
      let fileId = 0;
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      if ((urlInfo.type) === 'project') {
        let fileInfo = self.$store.getters['editor/getFileInfo'];
        fileId = (fileInfo.id);

      } else if ((urlInfo.type) === 'task' || (urlInfo.type) === 'school') {
        let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
        fileId = (fileTaskInfo.fileId);
      }
      document.getElementById(`target-${item.id}`).innerHTML = '';
      let params = Object();
      Reflect.set(params, 'constTime', 0);
      Reflect.set(params, 'taskId', null);
      Reflect.set(params, 'taskType', null);
      Reflect.set(params, 'isSaveVersion', 1);
      Reflect.set(params, 'sentId', (item.id));
      Reflect.set(params, 'content', '');
      Reflect.set(params, 'status', (item.status));
      Reflect.set(params, 'fileId', fileId);
      Reflect.set(params, 'sourceTagFragmentVo', null);

      let targetTemp = Object();
      Reflect.set(targetTemp, 'atomKey', (item.templateKey));
      Reflect.set(targetTemp, 'sort', `${parseInt((item.id).toString().substr(0, 5))}`);
      Reflect.set(targetTemp, 'data', '');
      Reflect.set(targetTemp, 'style', null);
      Reflect.set(targetTemp, 'id', (item.id));
      Reflect.set(targetTemp, 'dataType', 'text');
      Reflect.set(targetTemp, 'tagType', 'text');
      let atomsTemp = Array();
      atomsTemp.push(targetTemp);
      let targetTempTag = Object();
      Reflect.set(targetTempTag, 'atoms', targetTempTag);
      Reflect.set(targetTempTag, 'sort', 0);
      Reflect.set(targetTempTag, 'text', null);
      Reflect.set(targetTempTag, 'type', null);

      Reflect.set(params, 'targetTagFragmentVo', { 'atoms': atomsTemp, 'sort': 0, 'text': null, 'type': null });
      self.$store.dispatch('editor/updateTargetInfo', { params: params, type: 1 });
    },
    //拆分原文
    handleSplitFrangment() {
      const self = this;
      let editorMode = localStorage.getItem("editorMode");
      if (editorMode === 'mark') {
        this.$message.closeAll();
        this.$message.warning("修订模式下，不能进行拆分操作");
        return;
      }
      let tempInfo = self.$store.getters['editor/getTempSentenceIdInfo'];
      let fileId = 0;
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      if ((urlInfo.type) === 'project') {
        let fileInfo = self.$store.getters['editor/getFileInfo'];
        fileId = (fileInfo.id);

      } else if ((urlInfo.type) === 'task' || (urlInfo.type) === 'school') {
        let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
        fileId = (fileTaskInfo.fileId);
      }
      // let getSourceeditStatus = self.$store.getters["editor/getSourceeditStatus"];
      // if (getSourceeditStatus === true) {
      let cursorPositionInfo = self.$store.getters['editor/getCursorPositionInfo'];
      if (((tempInfo.type) === 'source') && !!(cursorPositionInfo.length)) {
        let params = Object();
        cursorPositionInfo.pop();
        Reflect.set(params, 'sentId', (tempInfo.item.id));
        Reflect.set(params, 'transFileId', fileId);
        Reflect.set(params, 'transFileSentList', cursorPositionInfo);
        self.$store.dispatch('editor/splitFragment', params).finally(() => {
          self.$store.dispatch('editor/recordCursorPosition', {});
          self.$store.dispatch('editor/setTempSentenceId', {});
          // if ((urlInfo.type) === 'project') {
          //        let taskContentListParams = self.$store.getters['editor/getTaskContentListParams'];
          //        Reflect.set(taskContentListParams, 'startSort', 1);
          //        self.$store.dispatch("editor/getFileContent",taskContentListParams);
          //        }else{
          //        let taskContentListParams = self.$store.getters['editor/getTaskContentListParams'];
          //        Reflect.set(taskContentListParams, 'startSort', 1);
          //        self.$store.dispatch("editor/getTaskContent",taskContentListParams);
          //    }
        })
      } else {
        self.$message({
          message: '请先将光标定位到原文',
          type: 'warning'
        });
      }
      // } else {
      //   self.$message.closeAll();
      //   self.$message({
      //     message: '请先点击编辑原文，再进行拆分操作',
      //     type: 'warning'
      //   });
      // }
    },
    //向下合并
    handleDownMerge() {
      const self = this;
      let editorMode = localStorage.getItem("editorMode");
      if (editorMode === 'mark') {
        this.$message.closeAll();
        this.$message.warning("修订模式下，不能进行拆分操作");
        return;
      }
      let tempInfo = self.$store.getters['editor/getTempSentenceIdInfo'];
      let fileId = 0;
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      if ((urlInfo.type) === 'project') {
        let fileInfo = self.$store.getters['editor/getFileInfo'];
        fileId = (fileInfo.id);

      } else if ((urlInfo.type) === 'task' || (urlInfo.type) === 'school') {
        let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
        fileId = (fileTaskInfo.fileId);
      }
      //  let getSourceeditStatus=self.$store.getters["editor/getSourceeditStatus"];
      // if(getSourceeditStatus===true){
      if ((tempInfo.type) === 'source') {
        //获取当前句的的dom--获取句子的父级--获取当前句子兄弟
        let currentId = (tempInfo.item.id);
        let dom = document.getElementById(`source-${currentId}`);
        let parentNodeDom = dom.parentNode.parentNode;
        let parentNodeNextDom = parentNodeDom.nextSibling;
        let nextId = parentNodeNextDom.getAttribute('infoid');
        let params = Object();
        Reflect.set(params, 'sourceSentId', currentId);
        Reflect.set(params, 'targetSentId', parseInt(nextId));
        Reflect.set(params, 'transFileId', fileId);
        self.$store.dispatch('editor/mergeFragment', params).then(() => {
          self.$store.dispatch('editor/recordCursorPosition', {});
          self.$store.dispatch('editor/setTempSentenceId', {});
          if ((urlInfo.type) === 'project') {
            let taskContentListParams = self.$store.getters['editor/getTaskContentListParams'];
            self.$store.dispatch("editor/getFileContent", taskContentListParams);
          } else {
            let taskContentListParams = self.$store.getters['editor/getTaskContentListParams'];
            self.$store.dispatch("editor/getTaskContent", taskContentListParams);
          }
        })
      } else {
        self.$message({
          message: '请先将光标定位到原文',
          type: 'warning'
        });
      }
      // }else{
      //   self.$message.closeAll();
      //     self.$message({
      //     message: '请先点击编辑原文，再进行合并操作',
      //     type: 'warning'
      //   });
      // }
    },
    //在记忆库中搜索
    handleSearchMemory() {
      const self = this;
      let params = Object();
      let searchKeyword = (self.mouseInfo.selectText);
      let fileId = 0;
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      if ((urlInfo.type) === 'project') {
        let fileInfo = self.$store.getters['editor/getFileInfo'];
        fileId = (fileInfo.id);

      } else if ((urlInfo.type) === 'task' || (urlInfo.type) === 'school') {
        let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
        fileId = (fileTaskInfo.fileId);
      }
      if (searchKeyword) {
        Reflect.set(params, 'sourcePar', searchKeyword);
        Reflect.set(params, 'fileId', fileId);
        Reflect.set(params, 'sourceIndex', (searchKeyword.length));
        self.$nextTick(() => {
          self.$store.dispatch('editor/setSentMemoryInfo', params)
        })
      } else {
        self.$message({
          message: '先选中要检索的句段',
          type: 'warning'
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
